//show/hide Back to Top button based on user scroll position
var toTopButton = document.querySelector('#back-to-top');
var prevScrollpos = window.pageYOffset;

window.onscroll = function() {
  var currentScrollPos = window.pageYOffset;

  if (currentScrollPos > 100) {
    toTopButton.style.display = 'flex';
  } else {
    toTopButton.style.display = 'none';
  }
  prevScrollpos = currentScrollPos;
}


// WEBPACK FOOTER //
// ./src/assets/fabricator/scripts/f-global.js